/* global axios */
import ApiClient from '../ApiClient';

// CRUD do FAQ do clube (admin). A Tamara cadastra pergunta/resposta e o Capitao
// usa como fonte de respostas. Backend embrulha o recurso em { faq: {...} }.
// R6.4: com versao='rascunho', o CRUD inteiro passa a operar sobre a copia do sandbox,
// e o que esta no ar (o que o Bira responde agora) fica intocado.
class FaqsAPI extends ApiClient {
  constructor() {
    super('fandata/faqs', { accountScoped: true });
  }

  get(versao) {
    return axios.get(this.url, { params: versao ? { versao } : {} });
  }

  create(faq, versao) {
    return axios.post(this.url, { faq, versao });
  }

  // T-186: `confirmar` separa o salvamento automático (o sistema guardou) da confirmação da
  // pessoa (eu terminei). Sem ele, tudo viraria "pronto" e a colega não distinguiria os dois.
  update(id, faq, versao, confirmar = false) {
    return axios.patch(`${this.url}/${id}`, { faq, versao, confirmar });
  }

  delete(id, versao) {
    return axios.delete(`${this.url}/${id}`, {
      params: versao ? { versao } : {},
    });
  }
}

export default new FaqsAPI();
